import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { LoginDialogService } from "src/app/services/authentication/login-dialog.service";
import { InitStoreAndListenersService } from "src/app/services/signal-r/init-store-listeners.service";
import { isFileViewerRoute } from "src/app/common/pipes/file-link/file-link.pipe";

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard implements CanActivate {

  homeRoutes = ['/', '//', '/home'];

  constructor(
    private auth: AuthenticationService,
    private dialog: LoginDialogService,
    private init: InitStoreAndListenersService,
    private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUrl = state.url; // this is the URL user is trying to access

    if (!this.auth.hasValidSession()) {
      if (currentUrl !== '/login') {
        // Keep file deep links across the login round trip; the viewer removes the key once it opens.
        if (isFileViewerRoute(currentUrl)) localStorage.setItem('redirect-route', currentUrl);
        this.router.navigate(['/login']); // or '/' if that's your login route
        this.auth.logout(); // clear token + cookie
      }

      return false;
    }

    if (!isFileViewerRoute(currentUrl)) this.init.initStore();
    return true;
  }


}
